// Indirizzi dei video degli esercizi.
//
// I video sono link di YouTube salvati nelle schede. Non si possono pero'
// mettere direttamente in un iframe dentro l'app: su iPhone la WebView non ha
// un indirizzo web e YouTube rifiuta di partire con "Errore 153".
// Il video passa quindi dalla pagina /video/:id del nostro server, che fa da
// contenitore con un indirizzo vero (vedi routes/video.js).

import { apiUrl } from './components/config';

// Riconosce le tre forme in cui puo' arrivare un link di YouTube:
// youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID.
export const idVideo = (url) => {
    if (typeof url !== 'string') return null;

    const trovato = url.match(/(?:v=|youtu\.be\/|\/embed\/)([A-Za-z0-9_-]{6,20})/);
    return trovato ? trovato[1] : null;
};

// Indirizzo da mettere nell'iframe. Se il link non e' riconosciuto si torna
// null: chi chiama mostra il messaggio al posto del riquadro.
export const urlPlayer = (url) => {
    const id = idVideo(url);
    return id ? `${apiUrl}/video/${id}` : null;
};

// Via d'uscita se il video non parte: aprirlo su YouTube.
export const urlYouTube = (url) => {
    const id = idVideo(url);
    return id ? `https://www.youtube.com/watch?v=${id}` : null;
};
